import type { DosageData } from "@qendo/medication";
import type { CycleData, ScheduleData, ScheduleTimeData, WeekdayData } from "@qendo/schedule";
import { isSameMinute } from "date-fns";
import { empty } from "~/util";
import { parseTime } from "~/util/dates";

export function dosagesMatch(one?: DosageData | null, two?: DosageData | null): boolean {
    return (
        (empty(one) && empty(two)) ||
        (one?.form === two?.form && one?.amount === two?.amount && one?.volume === two?.volume)
    );
}

export function schedulesMatch(one?: ScheduleData | null, two?: ScheduleData | null): boolean {
    return (
        (empty(one) && empty(two)) ||
        (one?.frequency === two?.frequency &&
            weekdaysMatch(one?.days, two?.days) &&
            one?.interval === two?.interval &&
            cyclesMatch(one?.cycle, two?.cycle) &&
            ((empty(one?.times) && empty(two?.times)) ||
                (one?.times?.length === two?.times?.length &&
                    ((one as ScheduleData).times as ScheduleTimeData[]).every((v, idx) =>
                        scheduleTimesMatch(v, ((two as ScheduleData).times as ScheduleTimeData[])[idx]),
                    ))))
    );
}

export function weekdaysMatch(one?: WeekdayData | null, two?: WeekdayData | null): boolean {
    return (
        (empty(one) && empty(two)) ||
        (one?.monday === two?.monday &&
            one?.tuesday === two?.tuesday &&
            one?.wednesday === two?.wednesday &&
            one?.thursday === two?.thursday &&
            one?.friday === two?.friday &&
            one?.saturday === two?.saturday &&
            one?.sunday === two?.sunday)
    );
}

export function cyclesMatch(one?: CycleData | null, two?: CycleData | null): boolean {
    return (
        (empty(one) && empty(two)) ||
        (one?.every === two?.every && one?.use_for === two?.use_for && one?.pause_for === two?.pause_for)
    );
}

export function scheduleTimesMatch(one?: ScheduleTimeData | null, two?: ScheduleTimeData | null): boolean {
    const now = new Date();

    return (
        (empty(one) && empty(two)) ||
        (isSameMinute(parseTime(one?.time ?? now), parseTime(two?.time ?? now)) &&
            ((empty(one?.amount) && empty(two?.amount)) || one?.amount === two?.amount))
    );
}
